import React from 'react'
import { useSelector } from 'react-redux'
import UnifiedFiles from 'features/bpDetails/Components/UnifiedFiles'
import EstateOwnedFolderView from 'features/bpList/Components/estates/EstateOwnedFolderView'
import { selectEstateOwnedFilesMeta } from 'ducks/estateDocuments/selectors'

const EstateOwnedDocuments = ({ estate, buildings = [] }) => {
  const estateId = estate?.id
  const ownedFilesMeta = useSelector(selectEstateOwnedFilesMeta)

  if (!estateId) return null

  return (
    <UnifiedFiles
      context='estate-owned'
      stateKeyId={`estate-owned:${estateId}`}
      automaticTabContent={<EstateOwnedFolderView estate={estate} buildings={buildings} />}
      showCustomTab={false}
      filesSource={[]}
      countsSource={{
        total: ownedFilesMeta.total,
        totalWithDuplicates: ownedFilesMeta.total,
        byCategory: {}
      }}
      canEdit={false}
    />
  )
}

export default EstateOwnedDocuments
